// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DkN7","delete":"styles_delete__1kgbF","update":"styles_update__8QUZJ","add":"styles_add__223q0"};